import controller from "@ctrl/controller";
import type { BlockId, ParagraphBlock } from "@ctrl/controller-rpc";

const { makeBlockId } = controller;

export const createBlockParagraph = (
  content = ""
): ParagraphBlock & { id: BlockId; type: "paragraph" } => ({
  id: makeBlockId(),
  type: "paragraph",
  content,
});
